import service from './service'

export default {
	// 使用者分頁
	getPage: params => service.post(`back/user/getPage`, params),
	// 取得使用者
	getDetail: params => service.get(`back/user/getDetail`, { params }),
	// 新增使用者
	add: params => service.post(`back/user/add`, params),
	// 編輯使用者
	update: params => service.put(`back/user/update`, params),
	// 刪除使用者
	remove: params => service.delete(`back/user/remove`, { params }),
	// 更新使用者狀態
	updateStatus: params => service.put(`back/user/updateStatus`, params),
	// 取得店家列表
	getStoreList: params => service.post(`back/user/getStoreList`, params),
	// 可綁定至店家的使用者清單
	getRoleBindableList: () => service.get(`back/user/getRoleBindableList`),
}
